import React, { useEffect, useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import './BannerSection.css';
import { getBanners, fetchBannersFromApi, BannerData } from '../../utils/bannerStorage';

const BannerSection: React.FC = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [banners, setBanners] = useState<BannerData[]>(getBanners());

  const loadBanners = async () => {
    const cached = getBanners();
    const activeCached = cached.filter(b => b.isActive !== false);
    if (activeCached.length > 0) {
      setBanners(activeCached);
    }
    const live = await fetchBannersFromApi();
    const activeLive = live.filter(b => b.isActive !== false);
    setBanners(activeLive);
  };

  useEffect(() => {
    loadBanners();
    checkIfMobile();
    
    window.addEventListener('resize', checkIfMobile);
    window.addEventListener('asw_banners_updated', loadBanners);

    return () => {
      window.removeEventListener('resize', checkIfMobile);
      window.removeEventListener('asw_banners_updated', loadBanners);
    };
  }, []);

  const checkIfMobile = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  const handleOpenChatbot = () => {
    // Open chatbot widget
    const chatBtn = document.querySelector('.chatbot-toggle-btn') as HTMLElement;
    if (chatBtn) {
      chatBtn.click();
    } else {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
    }
  };

  if (banners.length === 0) return null;

  return (
    <section className="hero-banner-section">
      <Carousel
        autoPlay={true}
        infiniteLoop={true}
        showStatus={false}
        showThumbs={false}
        interval={5000}
        transitionTime={600}
        showArrows={!isMobile}
        emulateTouch={true}
        dynamicHeight={false}
        stopOnHover={true}
        swipeable={true}
        useKeyboardArrows={true}
      >
        {banners.map((banner, index) => {
          const title = banner.title || 'Maruti Suzuki Ertiga';
          return (
            <div key={banner.id || index} className="hero-slide-wrapper">
              <div className="hero-slide-inner hero-banner-only">
                {/* Full Banner Graphic Image */}
                <div className="hero-image-full-frame">
                  <img 
                    src={banner.image} 
                    alt={title}
                    className="hero-full-banner-graphic"
                  />
                </div>

                {/* Right Side - Preserved Deal Card (Commented out for future use)
                <div className="hero-content-col">
                  <div className="hero-deal-card">
                    <div className="hero-badge">
                      <span className="badge-pulse"></span>
                      <span>🔥 COMMERCIAL SPECIAL OFFER</span>
                    </div>
                    <h1 className="hero-car-title">{title}</h1>
                    <p className="hero-car-subtitle">Ideal for Commercial & Tour & Travels Operators</p>
                    <div className="hero-price-grid">
                      <div className="price-item">
                        <span className="price-label">STARTING PRICE</span>
                        <span className="price-value">₹8,64,000</span>
                      </div>
                      <div className="price-item highlight-item">
                        <span className="price-label">DOWN PAYMENT</span>
                        <span className="price-value glow-text">₹86,400</span>
                      </div>
                      <div className="price-item">
                        <span className="price-label">EASY EMI</span>
                        <span className="price-value">₹12,456/mo</span>
                      </div>
                    </div>
                    <div className="hero-features-list">
                      <div className="feature-bullet">
                        <span className="feature-icon">⚡</span>
                        <span>100% On-Road Funding Available</span>
                      </div>
                      <div className="feature-bullet">
                        <span className="feature-icon">📄</span>
                        <span>Minimal Docs: PAN & Aadhaar Only</span>
                      </div>
                      <div className="feature-bullet">
                        <span className="feature-icon">🚕</span>
                        <span>T-Permit / All India Tourist Registration</span>
                      </div>
                    </div>
                    <div className="hero-cta-group">
                      <button 
                        className="hero-primary-btn"
                        onClick={handleOpenChatbot}
                      >
                        <span>📞 Get Instant Best Quote</span>
                        <i className="fas fa-arrow-right"></i>
                      </button>
                      <button 
                        className="hero-secondary-btn"
                        onClick={handleOpenChatbot}
                      >
                        <span>📄 View Pricing</span>
                      </button>
                    </div>
                  </div>
                </div>
                */}
              </div>
            </div>
          );
        })}
      </Carousel>
    </section>
  );
};

export default BannerSection;